import { backendUrl } from './../../env-config'
import { authAxios } from './../../helpers/axiosAuthInterceptor'

export const getAllSuperAdmins = async () => {
  return await authAxios.get(`${backendUrl}/super-admin/user/get-all-super-admins`)
}

export const getAllUsers = async () => {
  return await authAxios.get(`${backendUrl}/super-admin/user/get-all-users`)
}

export const getUserDetail = async (userId: string) => {
  return await authAxios.get(`${backendUrl}/super-admin/user/get-user/${userId}`)
}

export const getCoachCredentials = async (coachId: string) => {
  return await authAxios.get(`${backendUrl}/super-admin/user/coach-credentials/${coachId}`)
}

export const approveCoachCredential = async (coachId: string, credentialId: string) => {
  return await authAxios.post(`${backendUrl}/super-admin/user/coach-credentials/approve`, {
    coachId,
    credentialId,
  })
}

export const getUserAvailability = async (userId: string, isProvider: boolean) => {
  return await authAxios.get(`${backendUrl}/super-admin/user/availability/${userId}`, {
    params: { isProvider },
  })
}

export const getUserDayCalendar = async (userId: string, isProvider: boolean, date: string) => {
  return await authAxios.get(`${backendUrl}/super-admin/user/calendar-day/${userId}`, {
    params: { isProvider, date },
  })
}

export const getSlotMatch = async (params: {
  coachId: string
  clientId: string
  date: string
  duration: number
  bookedBy: 'client' | 'coach'
}) => {
  return await authAxios.get(`${backendUrl}/super-admin/user/slot-match`, { params })
}

export const searchUsers = async (text: string) => {
  return await authAxios.post(`${backendUrl}/super-admin/user/search-users`, {
    text,
  })
}

export const makeUserSuperAdmin = async (userId: string) => {
  return await authAxios.post(`${backendUrl}/super-admin/user/make-user-super-admin`, {
    userId,
  })
}

export const getAllReportViewers = async () => {
  return await authAxios.get(`${backendUrl}/super-admin/user/get-all-report-viewers`)
}

export const setUserReportViewer = async (userId: string, enabled: boolean) => {
  return await authAxios.post(`${backendUrl}/super-admin/user/set-report-viewer`, { userId, enabled })
}

export const removeUserFromSuperAdmin = async (userId: string) => {
  return await authAxios.post(`${backendUrl}/super-admin/user/remove-user-from-super-admin`, {
    userId,
  })
}
